import React, { useEffect, useRef, useState } from "react";
import {
  MandatoryStar,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../../Utils/helper";
import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import {
  AddUpdateAdvancePayoutAction,
  AddUpdateInsurerAdvancePayout,
  DeleteUploadPayoutDocuments,
  GetAdvanceAmountCaseNoDetailNetworkAction,
  GetInsurerHomeVisitAmount,
  GetInsurerTestDetail,
  PayoutUploadDocuments,
  getPayoutCountsNetworkAction,
  getPayoutDetailsNetworkAction,
} from "../../../redux/actions/PayoutAction";
import { AdvanceBulkUpload } from "./AdvanceBulkUpload";

export const AdvancePayout = ({
  // setIsOpenAdvance,
  isOpenAdvance,
  searchFilter,
  setadpTab,
}) => {
  const dispatch = useDispatch();
  const [providerType, setProvioderType] = useState(null);
  const [providerNameList, setProviderNameList] = useState(null);
  const [insurerPayload, setInsurerPayload] = useState(null);
  const [data, setData] = useState({ providerType: "", caseNo: "" });
  const [res, setRes] = useState(false);
  const [bulkUpload, setBulkUpload] = useState(false);
  const [list, setList] = useState([]);
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const [packageArr, setPackageArr] = useState([]);
  const [checkedPt, setCheckedPt] = useState([]);
  const [testOrPackage, setTestOrPackage] = useState(null);
  const [addTest, setAddTest] = useState([]);
  const [advInsAmount, setAdvInsAmount] = useState(null);
  const [insHvAmount, setInsHvAmount] = useState(null);
  const [providerFile, setProviderFile] = useState(null);
  const [insurerFile, setInsurerFile] = useState(null);
  const ref = useRef();
  const providerRef = useRef();
  const clearCaseNo = useRef();

  const uploadDcoument = (file, type, fileType) => {
    if(fileType === "provider"){
      const item = {
        cbuFileName:file?.name,
        filePAth:URL.createObjectURL(file)
      }
      setProviderFile(item)
    } else {
      setInsurerFile({
        insurerFileName:file?.name,
        insurerFilePath:URL.createObjectURL(file)
      })
    }
    const form = new FormData();
    form.append("AppointmentId", data?.appointmentId);
    form.append("BusinessType", data?.businessType);
    form.append("Attachments", file);
    form.append("isInsurerFile", type);
    form.append("providerId", data?.providerId);
    dispatch(PayoutUploadDocuments(form));
  };

  useEffect(() => {
    if (res === true) {
      dispatch(
        GetInsurerTestDetail({
          providerid: data?.providerId,
          caseNo: data?.caseNo,
          paymentFor: data?.paymentFor,
          isAdvanceFor: data?.isAdvanceFor,
        })
      );
    }
  }, [res]);

  useEffect(() => {
    if (data?.isAdvanceFor === "PACKAGE") {
      setTestOrPackage("PACKAGE");
      const arr = payoutReducer?.getInsurerPackageDetail?.lstPackage?.map(
        (ele, index) => ele
      );
      setPackageArr(arr);
      const arr1 = payoutReducer?.getInsurerPackageDetail?.lstPackage?.filter(
        (ele, index) => {
          if (ele?.amount > 0 && ele?.isPreExistAmount === true) {
            return ele;
          }
        }
      );
      setCheckedPt(arr1);
    } else if (
      data?.isAdvanceFor === "TEST" &&
      payoutReducer?.getInsurerPackageDetail?.lstPackage?.length === 0
    ) {
      setTestOrPackage("TEST");
      const arr = payoutReducer?.getInsurerPackageDetail?.lstTest?.map(
        (ele) => ele
      );
      setPackageArr(arr);

      const arr1 = payoutReducer?.getInsurerPackageDetail?.lstTest?.filter(
        (ele) => {
          if (ele?.amount > 0 && ele?.isPreExistAmount === true) {
            return ele;
          }
        }
      );
      setCheckedPt(arr1);
    } else if (
      data?.isAdvanceFor === "TEST" &&
      payoutReducer?.getInsurerPackageDetail?.lstPackage?.length > 0
    ) {
      setTestOrPackage("ADDTEST");
      const arr = payoutReducer?.getInsurerPackageDetail?.lstPackage?.map(
        (ele) => ele
      );
      setPackageArr(arr);

      const arr4 = payoutReducer?.getInsurerPackageDetail?.lstPackage?.filter(
        (ele) => {
          if (ele?.amount > 0 && ele?.isPreExistAmount === true) {
            return ele;
          }
        }
      );
      const arr1 = payoutReducer?.getInsurerPackageDetail?.lstPackage?.map(
        (ele, index) => {
          return payoutReducer?.getInsurerPackageDetail?.lstPackage[
            index
          ]?.lstPackageTests?.map((item) => {
            return item;
          });
        }
      );
      setList(arr1.flat());
      const arr5 = arr1.flat().filter((ele) => {
        if (ele?.amount > 0 && ele?.isPreExistAmount === true) {
          return ele;
        }
      });

      const arr3 = payoutReducer?.getInsurerPackageDetail?.lstTest?.map(
        (ele) => ele
      );
      setAddTest(arr3);

      const arr6 = payoutReducer?.getInsurerPackageDetail?.lstTest?.filter(
        (ele) => {
          if (ele?.amount > 0 && ele?.isPreExistAmount === true) {
            return ele;
          }
        }
      );
      setCheckedPt([...arr4, ...arr6, ...arr5]);
    }

  }, [payoutReducer?.getInsurerPackageDetail]);

  const changeHandler = (name, value) => {
    setData({ ...data, [name]: value });
    if (name === "insurerAdvanceAmount") {
      setAdvInsAmount(value);
    }
  };

  useEffect(() => {
    if (data?.hvPaymentFor === "Syscharge") {
      let res = dispatch(
        GetInsurerHomeVisitAmount({
          caseNo: data?.caseNo,
          providerId: data?.providerId,
          hVpaymentFor: data?.hvPaymentFor,
        })
      ).then((res) => {
        if (res) {
          isLoadingAction(false, dispatch);
          setData({ ...data, insurerHomeVisitAmount: res?.data?.results[0] });
          setInsHvAmount(res?.data?.results[0]);
        }
      });
    }
  }, [data?.hvPaymentFor === "Syscharge"]);

  const handleApply = async (caseNo, providerType, providerid, flag) => {
    setRes(false);
    // event.stopPropagation();
    const res = await dispatch(
      GetAdvanceAmountCaseNoDetailNetworkAction({
        caseNo: caseNo,
        providerType: providerType,
        providerId: providerid,
      })
    )
      .then((res) => {
        isLoadingAction(false, dispatch);
        if (res?.data?.status === true) {
          if (flag === "A") {
            setProviderNameList(res?.data?.results);
            setData(res?.data?.results[0]);
            
            if (res?.data?.results[0]?.isAdvanceFor !== "ENTIRE CASE") {
              setAdvInsAmount(res?.data?.results[0]?.insurerAdvanceAmount);
            }

          } else {
            setData(res?.data?.results[0]);
            setAdvInsAmount(res?.data?.results[0]?.insurerAdvanceAmount);
          }

          if(res?.data?.results[0]?.cbuFileName !== null){
            setProviderFile({
              cbuFileName: res?.data?.results[0]?.cbuFileName,
              filePath: res?.data?.results[0]?.filePath,
            });
          }

          if(res?.data?.results[0]?.insurerFileName !== null){
            setInsurerFile({
              insurerFileName:res?.data?.results[0]?.insurerFileName,
              insurerFilePath:res?.data?.results[0]?.insurerFilePath
            })
          }

          setRes(true);
        } else {
          getSnackbarSuccess("warning", res?.data?.message, dispatch);
        }
      })
      .catch((err) => {
        isLoadingAction(false, dispatch);
      });
  };

  const insurerPriceHandler = (id, name, value) => {
    let arr = list?.map((ele, index) => {
      if (id === index) {
        ele[name] = value;
      }
      return ele;
    });
    setList(arr);
  };

  const packagePriceHandler = (id, name, value) => {
    const arr = packageArr?.map((ele, index) => {
      if (id === index) {
        ele[name] = value;
      }
      return ele;
    });
    setPackageArr(arr);
  };

  const addTestPriceHandler = (id, name, value) => {
    const arr = addTest?.map((ele, index) => {
      if (id === index) {
        ele[name] = value;
      }
      return ele;
    });
    setAddTest(arr);
  };

  useEffect(() => {
    if (data?.isAdvanceFor) {
      dispatch(
        GetInsurerTestDetail({
          // ...insurerPayload,
          providerid: data?.providerId,
          caseNo: data?.caseNo,
          paymentFor: data?.paymentFor,
          isAdvanceFor: data?.isAdvanceFor,
        })
      );
    }
  }, [data?.isAdvanceFor]);

  useEffect(() => {
    let sum = 0;

    let sum2 = checkedPt?.forEach((ele) => {
      sum = sum + +ele?.amount;
    });
    if (
      checkedPt?.length === 0 &&
      (data?.isAdvanceFor === "TEST" || data?.isAdvanceFor === "PACKAGE")
    ) {
      setAdvInsAmount(0);
    } else if (checkedPt?.length > 0) {
      setAdvInsAmount(sum);
    } else if (data?.isAdvanceFor === "ENTIRE CASE") {
      setData({
        ...data,
        insurerAdvanceAmount:
          payoutReducer?.getInsurerPackageDetail?.lstPackage[0]?.amount,
      });
      setAdvInsAmount(
        payoutReducer?.getInsurerPackageDetail?.lstPackage[0]?.amount
      );
    }
  }, [
    payoutReducer?.getInsurerPackageDetail,
    checkedPt,
    list,
    packageArr,
    addTest,
  ]);


  const handleClear = () => {
    // setIsOpenAdvance(false);
    setProviderFile(null)
    setInsurerFile(null)
    providerRef.current.value = "";
    clearCaseNo.current.value = "";
    setData({
      ...data,
      providerType: "",
      caseNo: "",
      centreName: "",
      paymentType: null,
      advanceAmount: "",
      tdsFlag: null,
      utr: null,
      remarks: "",
    });
    setList([]);
    setPackageArr([]);
    setProvioderType(null);
    setRes(false);
    setCheckedPt([]);
    setTestOrPackage([]);
    ref.current.reset();
    setAdvInsAmount(null);
    setPackageArr(null);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // event.stopPropagation();
    event.target.className += " was-validated";
    if (event.target.checkValidity()) {
      const res = dispatch(
        AddUpdateAdvancePayoutAction({
          ...data,
          providerType: providerType,
          action: "PROVIDERADVANCEPAY",
        })
      )
        .then((res) => {
          isLoadingAction(false, dispatch);
          if (res?.data?.status === true) {
            getSnackbarSuccess("success", res?.data?.message, dispatch);
            dispatch(getPayoutDetailsNetworkAction(searchFilter));
            dispatch(
              getPayoutCountsNetworkAction({ ...searchFilter, page: 1 })
            );
          } else {
            getSnackbarSuccess("warning", res?.data?.message, dispatch);
          }
        })
        .catch((err) => {
          isLoadingAction(false, dispatch);
        });
    }
  };

  const handleInsurerSubmit = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    let flag = false;
    const arr = checkedPt?.filter((ele) => {
      if (ele?.amount === 0 || ele?.amount === "" || ele?.amount === null) {
        flag = true;
        return ele;
      }
    });

    if (flag === true) {
      getSnackbarSuccess("info", "Please provide amount ", dispatch);
    }
    if (flag === false) {
      if (event.target.checkValidity()) {
        const arr = checkedPt.map((ele) => {
          return {
            isPackage: testOrPackage === "PACKAGE" ? 1 : 0,
            isAdvanceFor: data?.isAdvanceFor,
            appointmentId: data?.appointmentId,
            amount: ele?.amount,
            clientId: ele?.clientId,
            isAdvanceFor: ele?.isAdvanceFor,
            packageId: ele?.packageId,
            packageName: ele?.packageName,
            testId: ele?.testId,
            testName: ele?.testName,
            type: ele?.type,
          };
        });
        let payload = {
          ...data,
          ...insurerPayload,
          action: "INSURERADVANCEPAY",
          insurerAdvanceAmountDetails: arr,
          // insurerHomeVisitAmount:insHvAmount
        };
        const res = dispatch(AddUpdateInsurerAdvancePayout(payload))
          .then((res) => {
            isLoadingAction(false, dispatch);
            if (res?.data?.status === true) {
              getSnackbarSuccess("success", res?.data?.message, dispatch);
            } else {
              getSnackbarSuccess("warning", res?.data?.message, dispatch);
            }
          })
          .catch((err) => {
            isLoadingAction(false, dispatch);
          });
      }
    }
  };

  return (
    <>
      <div className="right-section" style={{ padding: "20px" }}>
        <div className="d-flex justify-content-between">
          <div
            className="back-buttondiv"
            onClick={() => {
              setadpTab(false);
              setList([]);
              setPackageArr([]);
              setCheckedPt([]);
              setAddTest([]);
              setData({ providerType: "", caseNo: "" });
            }}
          >
            <i className="fa-solid fa-circle-arrow-left"></i>
            <h6 style={{ cursor: "pointer" }}>Back</h6>
          </div>
        </div>
        <div className="staff-details-header pb-3 d-flex justify-content-between align-items-center edit-save-css">
          <div>
            <h4
              className="font-bold text-highlight"
              style={{ letterSpacing: "1px" }}
            >
              Advance Payout Details
            </h4>
          </div>
          <div className="d-flex gap-2">
            <button
              className="btn search__btn"
              type="button"
              style={{ border: "none" }}
              onClick={() => handleClear()}
            >
              Clear All
            </button>
            <button
              className="btn search__btn"
              type="button"
              style={{ border: "none" }}
              onClick={() => setBulkUpload(true)}
            >
              Bulk Upload
            </button>
          </div>
        </div>
        <div className="card staff-details-section mt20">
          <div className="card-body" style={{ padding: "12px" }}>
            <div className="custom-container">
              <form onSubmit={handleSubmit} noValidate ref={ref}>
                <div className="row">
                  <h4
                    className="font-bold text-highlight"
                    style={{ letterSpacing: "1px" }}
                  >
                    Provider Advance Payout
                  </h4>
                  <div className="col-lg-3 col-md-5">
                    <label className="col-form-label">Select Provider</label>
                    <select
                      class="form-select p-2"
                      value={providerType}
                      ref={providerRef}
                      disabled={res === true}
                      onChange={(e) => {
                        setRes(false);
                        setProvioderType(e.target.value);
                        
                        setData({ providerType: e.target.value, caseNo: "" });
                        // ref.current.reset();
                        clearCaseNo.current.value = "";
                      }}
                    >
                      <option value={""}> Select Provider Type</option>
                      <option value={"Existing Provider"}>
                        Existing Provider
                      </option>
                      <option value={"Not Existing Provider"}>
                        Not Existing Provider{" "}
                      </option>
                    </select>
                  </div>
                  <div className="col-lg-3 col-md-5">
                    <label className="col-form-label">Case No.</label>
                    <div class="input-group mb-2 mr-sm-2">
                      <input
                        type="text"
                        class="form-control"
                        id="inlineFormInputGroupUsername2"
                        style={{ padding: "7px" }}
                        disabled={data?.providerType === "" || res === true}
                        placeholder="Enter Case No"
                        ref={clearCaseNo}
                        value={data?.caseNo ? data?.caseNo : ""}
                        onChange={(e) => {
                          setInsurerPayload({
                            ...insurerPayload,
                            caseNo: e.target.value.toUpperCase(),
                          });
                          setData({
                            ...data,
                            caseNo: e.target.value.toUpperCase(),
                          });
                        }}
                        onKeyPress={(event) => {
                          if (event.key === " ") {
                            event.preventDefault();
                          }
                        }}
                      />
                      <div class="input-group-prepend">
                        <button
                          class="input-group-text search"
                          type="button"
                          onClick={() =>
                            handleApply(
                              data?.caseNo,
                              data?.providerType,
                              null,
                              "A"
                            )
                          }
                          disabled={
                            data?.caseNo === undefined ||
                            data?.caseNo === "" ||
                            res === true
                          }
                          style={{
                            cursor: "pointer",
                            padding: " 8px 5px",

                            // width: "80px",
                            justifyContent: "center",
                          }}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                  {res === true && (
                    <>
                      <div className="col-lg-3 col-md-5">
                        <label className="col-form-label">
                          Provider Name
                          <MandatoryStar />
                        </label>
                        <select
                          class="form-select p-2"
                          value={data?.providerId}
                          required
                          onChange={(e) => {
                            handleApply(
                              data?.caseNo,
                              data?.providerType,
                              e.target.value,
                              "B"
                            );
                            setProviderFile(null)
                        setInsurerFile(null)
                            setList([]);
                            setPackageArr([]);
                            setRes(false);
                            setCheckedPt([]);
                            setTestOrPackage([]);
                            setAdvInsAmount(null);
                            setPackageArr(null);
                          }}
                        >
                          {/* <option value="">Select Provider</option> */}
                          {providerNameList?.map((ele) => {
                            return (
                              <option value={ele?.providerId}>
                                {ele?.providerName}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      {providerType === "Not Existing Provider" && (
                        <div className="col-lg-3 col-md-5">
                          <label className="col-form-label">
                            Centre Name
                            <MandatoryStar />
                          </label>
                          <input
                            type="text"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={data?.centreName}
                            class="form-control"
                            id="inlineFormInputGroupUsername2"
                            placeholder="Enter Centre Name"
                            style={{ padding: "7px" }}
                            value={data?.centreName}
                            required
                            onChange={(e) => {
                              changeHandler("centreName", e.target.value);
                            }}
                            onKeyPress={(e) => {
                              const re = /^[a-zA-Z\s]*$/;
                              if (
                                e.target.value.trim() === "" &&
                                e.key === " "
                              ) {
                                e.preventDefault();
                                return;
                              }
                              // Allow only one space between the first name and the last name
                              if (
                                e.key === " " &&
                                e.target.value.split("").length < 1
                              ) {
                                e.preventDefault();
                                return;
                              }
                              if (!re.test(e.target.value + e.key)) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                      )}

                      <div className="col-lg-3 col-md-5">
                        <label className="col-form-label">
                          Payment Type <MandatoryStar />
                        </label>
                        <select
                          class="form-select p-2"
                          value={
                            data?.paymentType === null ? "" : data?.paymentType
                          }
                          required
                          onChange={(e) =>
                            changeHandler("paymentType", e.target.value)
                          }
                        >
                          <option value={""}> Select Payment Type</option>
                          <option value={"Advance Paid"}>Advance Paid</option>
                          <option value={"Refund"}>Refund </option>
                          <option value={"Partial Refund"}>
                            Partial Refund{" "}
                          </option>
                          <option value={"Payment Lost"}>Payment Lost </option>
                        </select>
                      </div>
                      <div class=" col-lg-3 col-md-5  mb-2 mr-sm-2 col-lg-2 col-md-2 ">
                        <label className="col-form-label">
                          Amount
                          <MandatoryStar />
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          style={{ padding: "7px" }}
                          id="inlineFormInputGroupUsername2"
                          placeholder="Enter Amount"
                          value={data?.advanceAmount}
                          min={1}
                          required
                          onChange={(e) =>
                            changeHandler("advanceAmount", e.target.value)
                          }
                        />
                      </div>
                      {data?.paymentType === "Advance Paid" && (
                        <div className="col-lg-3 col-md-5">
                          <label className="col-form-label">
                            TDS <MandatoryStar />
                          </label>
                          <select
                            class="form-select p-2"
                            value={data?.tdsFlag === null ? "" : data?.tdsFlag}
                            required
                            onChange={(e) =>
                              changeHandler(
                                "tdsFlag",
                                e.target.value === "true"
                                  ? true
                                  : e.target.value === "false"
                                  ? false
                                  : e.target.value
                              )
                            }
                          >
                            <option value=""> Select TDS</option>
                            <option value={true}>Yes</option>
                            <option value={false}>No </option>
                          </select>
                        </div>
                      )}
                      {data?.paymentType === "Advance Paid" && (
                        <div className="col-lg-3 col-md-5">
                          <label className="col-form-label">
                            UTR <MandatoryStar />
                          </label>
                          <input
                            type="text"
                            style={{ padding: "7px" }}
                            class="form-control"
                            id="inlineFormInputGroupUsername2"
                            placeholder="UTR"
                            value={data?.utr}
                            required
                            onChange={(e) =>
                              changeHandler("utr", e.target.value)
                            }
                            onKeyPress={(e) => {
                              if (e.key === " ") {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                      )}
                      <div className="col-lg-3 col-md-5">
                        <label className="col-form-label">Remarks</label>
                        <input
                          type="text"
                          style={{ padding: "7px" }}
                          class="form-control"
                          id="inlineFormInputGroupUsername2"
                          placeholder="Remarks"
                          value={data?.remarks}
                          min={1}
                          onChange={(e) =>
                            changeHandler("remarks", e.target.value)
                          }
                        />
                      </div>
                    
                      <div className="col-lg-3 col-md-5">
                        <label className="col-form-label">Upload Report</label>
                        {providerFile === null && (
                          <input
                            type="file"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (
                                file.type !== "image/png" &&
                                file.type !== "image/PNG" &&
                                file.type !== "image/jpg" &&
                                file.type !== "image/JPG" &&
                                file.type !== "image/JPEG" &&
                                file.type !== "image/jpeg" &&
                                file.type !== "application/pdf" &&
                                file.type !== "application/pdf"
                              ) {
                                getSnackbarSuccess(
                                  "error",
                                  "Only PNG,JPG,JPEG and PDF is allowed",
                                  dispatch
                                );
                                e.target.value = null;
                                return;
                              } else {
                               
                                uploadDcoument(file, false,"provider");
                              }
                            }}
                            className="form-control form-select-admin inputbgavanish serviceicon"
                          />
                        )}

                        {providerFile !== null && (
                          <label className="d-flex justify-content-between form-control form-select-admin inputbgavanish">
                            <a
                              href={providerFile?.filePAth}
                              target="_blank"
                              className="serviceImagename"
                              style={{ color: "black" }}
                            >
                              {providerFile?.cbuFileName}
                            </a>
                            <span
                              onClick={() => {
                                setData({ ...data, filePath: "" });
                                setProviderFile(null)
                                dispatch(
                                  DeleteUploadPayoutDocuments({
                                    appointmentId: data?.appointmentId,
                                    businessType: data?.businessType,
                                    isInsurerFile: false,
                                    providerId: data?.providerId,
                                  })
                                );
                              }}
                            >
                              <img src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png" />
                            </span>
                          </label>
                        )}
                      </div>
                      <div class=" col-lg-3 col-md-5 d-flex gap-2">
                        <button
                          className="input-group-text search "
                          type="submit"
                          style={{
                            cursor: "pointer",
                            marginTop: "35px",
                            justifyContent: "end",
                            height: "43px",
                          }}
                        >
                          Submit
                        </button>
                        {/* <button
                          className="input-group-text search "
                          type="button"
                          style={{
                            cursor: "pointer",
                            marginTop: "35px",
                            justifyContent: "end",
                            height: "43px",
                          }}
                          onClick={() => {
                            handleCbuClear();
                          }}
                        >
                          Clear
                        </button> */}
                      </div>
                    </>
                  )}
                </div>
              </form>
            </div>
            {res === true && data?.businessType === "IBU" && (
              <div className="custom-container">
                <form onSubmit={handleInsurerSubmit} noValidate ref={ref}>
                  <div className="row">
                    <h4
                      className="font-bold text-highlight"
                      style={{ letterSpacing: "1px" }}
                    >
                      Insurer Advance Payout
                    </h4>
                    <>
                      <div class=" col-lg-3 col-md-5  mb-2 ">
                        <label className="col-form-label">
                          Insurer Name
                          <MandatoryStar />
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          style={{ padding: "7px" }}
                          // id="inlineFormInputGroupUsername2"
                          placeholder="Insurer Name"
                          value={data?.clientName}
                          disabled={true}
                          // min={1}
                          required
                          onChange={(e) =>
                            changeHandler("clientName", e.target.value)
                          }
                        />
                      </div>
                      <div className="col-lg-3 col-md-5">
                        <label className="col-form-label">
                          Provider Name
                          <MandatoryStar />
                        </label>
                        <select
                          class="form-select p-2"
                          value={data?.providerId}
                          required
                          disabled
                          onChange={(e) => {
                            handleApply(
                              data?.caseNo,
                              data?.providerType,
                              e.target.value,
                              "B"
                            );
                          }}
                        >
                          {/* <option value="">Select Provider</option> */}
                          {providerNameList?.map((ele) => {
                            return (
                              <option value={ele?.providerId}>
                                {ele?.providerName}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="col-lg-3 col-md-5">
                        <label className="col-form-label">
                          Payment For <MandatoryStar />
                        </label>
                        <select
                          class="form-select p-2"
                          value={data?.paymentFor}
                          required
                          onChange={(e) => {
                            setList([]);
                            setPackageArr([]);
                            setCheckedPt([]);
                            setAddTest([]);
                            setData({
                              ...data,
                              paymentFor: e.target.value,
                            });
                            dispatch(
                              GetInsurerTestDetail({
                                // ...insurerPayload,
                                providerid: data?.providerId,
                                caseNo: data?.caseNo,
                                paymentFor: e.target.value,
                                isAdvanceFor: data?.isAdvanceFor,
                              })
                            );
                          }}
                        >
                          <option value={""}> Select Payment For</option>
                          <option value={"Syscharge"}>System Charges</option>
                          <option value={"AdvaAmt"}>Advance Amount </option>
                        </select>
                      </div>
                      {(data?.paymentFor === "Syscharge" ||
                        data?.paymentFor === "AdvaAmt") && (
                        <div className="col-lg-3 col-md-5">
                          <label className="col-form-label">
                            Advance For <MandatoryStar />
                          </label>
                          <select
                            class="form-select p-2"
                            value={
                              data?.isAdvanceFor === null
                                ? ""
                                : data?.isAdvanceFor
                            }
                            required
                            onChange={(e) => {
                              // changeHandler("isAdvanceFor", e.target.value)
                              setList([]);
                              setPackageArr([]);
                              setCheckedPt([]);
                              setAddTest([]);
                              setData({
                                ...data,
                                isAdvanceFor: e.target.value,
                              });
                            }}
                          >
                            <option value=""> Select Advance For</option>
                            <option value={"ENTIRE CASE"}>ENTIRE CASE</option>
                            <option value={"PACKAGE"}>PACKAGE </option>
                            <option value={"TEST"}>TEST</option>
                          </select>
                        </div>
                      )}

                      {data?.isAdvanceFor === "ENTIRE CASE" && (
                        <div class=" col-lg-3 col-md-5  mb-2 ">
                          <label className="col-form-label">
                            Entire Case Amount
                            <MandatoryStar />
                          </label>
                          <input
                            type="number"
                            class="form-control"
                            style={{ padding: "7px" }}
                            id="inlineFormInputGroupUsername2"
                            placeholder="Entire Case Amount"
                            value={advInsAmount}
                            min={1}
                            required
                            onChange={(e) =>
                              changeHandler(
                                "insurerAdvanceAmount",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      )}
                      {(data?.isAdvanceFor === "PACKAGE" ||
                        data?.isAdvanceFor === "TEST") && (
                        <div class=" col-lg-3 col-md-5  mb-2 ">
                          <label className="col-form-label">
                            Advance Insurer Rate
                            <MandatoryStar />
                          </label>
                          <input
                            type="number"
                            class="form-control"
                            style={{ padding: "7px" }}
                            // id="inlineFormInputGroupUsername2"
                            placeholder="Advance Insurer Rate"
                            value={advInsAmount}
                            // min={1}
                            required
                            // onChange={(e) =>
                            //   setAdvInsAmount()
                            // }
                          />
                        </div>
                      )}
                      <div className="col-lg-3 col-md-5">
                        <label className="col-form-label">
                          Insurer HV Payment For <MandatoryStar />
                        </label>
                        <select
                          class="form-select p-2"
                          value={data?.hvPaymentFor}
                          required
                          onChange={(e) => {
                            changeHandler("hvPaymentFor", e.target.value);
                          }}
                        >
                          <option value={""}> Select HV Payment For</option>
                          <option value={"Syscharge"}>System Charges</option>
                          <option value={"AdvaAmt"}>Advance Amount </option>
                        </select>
                      </div>
                      {data?.hvPaymentFor === "AdvaAmt" && (
                        <div class=" col-lg-3 col-md-5  mb-2 ">
                          <label className="col-form-label">
                            Advance Insurer HV Charge
                            <MandatoryStar />
                          </label>
                          <input
                            type="number"
                            class="form-control"
                            style={{ padding: "7px" }}
                            // id="inlineFormInputGroupUsername2"
                            placeholder=" Advance Insurer HV Charge"
                            value={data?.insurerHomeVisitAmount}
                            min={1}
                            required
                            onChange={(e) =>
                              changeHandler(
                                "insurerHomeVisitAmount",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      )}

                      <div className="col-lg-3 col-md-5">
                        <label className="col-form-label">
                          Payment Type <MandatoryStar />
                        </label>
                        <select
                          class="form-select p-2"
                          value={
                            data?.insurerPaymentType === null
                              ? ""
                              : data?.insurerPaymentType
                          }
                          required
                          onChange={(e) =>
                            changeHandler("insurerPaymentType", e.target.value)
                          }
                        >
                          <option value={""}> Select Payment Type</option>
                          <option value={"Advance Paid"}>Advance Paid</option>
                          {/* <option value={"Refund"}>Refund </option>
                          <option value={"Partial Refund"}>
                            Partial Refund{" "}
                          </option>
                          <option value={"Payment Lost"}>Payment Lost </option> */}
                        </select>
                      </div>
                      <div className="col-lg-3 col-md-5">
                        <label className="col-form-label">Remarks</label>
                        <input
                          type="text"
                          style={{ padding: "7px" }}
                          class="form-control"
                          id="inlineFormInputGroupUsername2"
                          placeholder="Remarks"
                          value={data?.insurerRemarks}
                          min={1}
                          onChange={(e) =>
                            changeHandler("insurerRemarks", e.target.value)
                          }
                        />
                      </div>
                      <div className="col-lg-3 col-md-5">
                        <label className="col-form-label">Insurer Approval Name</label>
                        <input
                          type="text"
                          style={{ padding: "7px" }}
                          class="form-control"
                          id="inlineFormInputGroupUsername2"
                          placeholder="Insurer Approval Name"
                          value={data?.insurerApproverName}
                          min={1}
                          required
                          onChange={(e) =>
                            changeHandler("insurerApproverName", e.target.value)
                          }
                        />
                      </div>
                      <div className="col-lg-3 col-md-5">
                        <label className="col-form-label">Upload Report</label>
                        {insurerFile === null && (
                          <input
                            type="file"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (
                                file.type !== "image/png" &&
                                file.type !== "image/PNG" &&
                                file.type !== "image/jpg" &&
                                file.type !== "image/JPG" &&
                                file.type !== "image/JPEG" &&
                                file.type !== "image/jpeg" &&
                                file.type !== "application/pdf" &&
                                file.type !== "application/pdf"
                              ) {
                                getSnackbarSuccess(
                                  "error",
                                  "Only PNG,JPG,JPEG and PDF is allowed",
                                  dispatch
                                );
                                e.target.value = null;
                                return;
                              } else {
                                uploadDcoument(file, true,"insurer");
                              }
                            }}
                            className="form-control form-select-admin inputbgavanish serviceicon"
                          />
                        )}

                        {insurerFile !== null && (
                          <label className="d-flex justify-content-between form-control form-select-admin inputbgavanish">
                            <a
                              href={insurerFile?.insurerFilePath}
                              target="_blank"
                              className="serviceImagename"
                              style={{ color: "black" }}
                            >
                              {insurerFile?.insurerFileName}
                            </a>
                            <span
                              onClick={() => {
                                setData({ ...data, insurerFilePath: "" });
                                setInsurerFile(null)
                                dispatch(
                                  DeleteUploadPayoutDocuments({
                                    appointmentId: data?.appointmentId,
                                    businessType: data?.businessType,
                                    isInsurerFile: true,
                                    providerId: data?.providerId,
                                  })
                                );
                              }}
                            >
                              <img src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png" />
                            </span>
                          </label>
                        )}
                      </div>

                      {data?.isAdvanceFor === "PACKAGE" &&
                      payoutReducer?.getInsurerPackageDetail?.lstPackage
                        ?.length === 0 ? (
                        ""
                      ) : (
                        <div class=" col-lg-3 col-md-5 d-flex gap-2">
                          <button
                            className="input-group-text search "
                            type="submit"
                            style={{
                              cursor: "pointer",
                              marginTop: "35px",
                              justifyContent: "end",
                              height: "43px",
                            }}
                          >
                            Submit
                          </button>
                        </div>
                      )}
                    </>
                  </div>
                  {(data?.isAdvanceFor === "PACKAGE" ||
                    data?.isAdvanceFor === "TEST") &&
                    (payoutReducer?.getInsurerPackageDetail?.lstPackage
                      ?.length > 0 ||
                      payoutReducer?.getInsurerPackageDetail?.lstTest?.length >
                        0) && (
                      <div className="staff-table creation-table">
                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Select Checkbox</th>
                                <th className="w60">Advance For</th>
                                <th>Advance Insurer Rate</th>
                              </tr>
                            </thead>
                            <tbody>
                              {packageArr?.map((ele, index) => {
                                return (
                                  <>
                                    <tr>
                                      <td>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          style={{ margin: "0 50%" }}
                                          checked={checkedPt?.some(
                                            (item) => item === ele
                                          )}
                                          onChange={(e) => {
                                            if (testOrPackage === "PACKAGE") {
                                              e.target.checked === true
                                                ? setCheckedPt([
                                                    ...checkedPt,
                                                    ele,
                                                  ])
                                                : setCheckedPt(
                                                    checkedPt?.filter(
                                                      (item) =>
                                                        item?.packageId !==
                                                        ele?.packageId
                                                    )
                                                  );
                                            } else if (
                                              testOrPackage === "TEST"
                                            ) {
                                              e.target.checked === true
                                                ? setCheckedPt([
                                                    ...checkedPt,
                                                    ele,
                                                  ])
                                                : setCheckedPt(
                                                    checkedPt?.filter(
                                                      (item) =>
                                                        item?.testId !==
                                                        ele?.testId
                                                    )
                                                  );
                                            } else if (
                                              testOrPackage === "ADDTEST"
                                            ) {
                                              if (e.target.checked === true) {
                                                const arr1 = list?.map(
                                                  (item) => {
                                                    if (
                                                      ele?.packageId ===
                                                        item?.packageId &&
                                                      item?.type === null
                                                    ) {
                                                      return {
                                                        ...item,
                                                        amount: 0,
                                                      };
                                                    } else {
                                                      return item;
                                                    }
                                                  }
                                                );
                                                const arr2 = checkedPt?.filter(
                                                  (value) =>
                                                    value?.packageId !==
                                                    ele?.packageId
                                                );
                                                setList(arr1);
                                                setCheckedPt([...arr2, ele]);
                                                // }
                                              } else {
                                                setCheckedPt(
                                                  checkedPt?.filter(
                                                    (item) =>
                                                      item?.packageId !==
                                                      ele?.packageId
                                                  )
                                                );
                                                const arr = packageArr?.map(
                                                  (value) => {
                                                    if (
                                                      value?.packageId ===
                                                      ele?.packageId
                                                    ) {
                                                      return {
                                                        ...value,
                                                        amount: 0,
                                                      };
                                                    } else {
                                                      return value;
                                                    }
                                                  }
                                                );
                                                setPackageArr(arr);
                                              }
                                            }
                                          }}
                                        />
                                      </td>
                                      <td className="text-center">
                                        {data?.isAdvanceFor === "PACKAGE" ||
                                        testOrPackage === "ADDTEST" ? (
                                          <>
                                            <span style={{ fontWeight: "900" }}>
                                              {ele?.type} -
                                            </span>{" "}
                                            {ele?.packageName}
                                          </>
                                        ) : (
                                          ele?.testName
                                        )}
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          className={
                                            "__inputs font-medium text-black"
                                          }
                                          style={{ width: "100%" }}
                                          placeholder="Enter here..."
                                          disabled={
                                            !checkedPt?.some(
                                              (item) => item === ele
                                            )
                                          }
                                          value={ele?.amount}
                                          onKeyDown={(e) => {
                                            if (
                                              e.key === " " ||
                                              e.key === "-" ||
                                              e.key === "+"
                                            ) {
                                              e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                                            }
                                          }}
                                          onChange={(e) =>
                                            packagePriceHandler(
                                              index,
                                              "amount",
                                              e.target.value
                                            )
                                          }
                                          required
                                        />
                                      </td>
                                    </tr>
                                    {list?.map((item, index) => {
                                      if (ele?.packageId === item?.packageId) {
                                        return (
                                          <tr key={index}>
                                            <td>
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                style={{ margin: "0 50%" }}
                                                checked={checkedPt?.some(
                                                  (value) => value === item
                                                )}
                                                onClick={(e) => {
                                                  if (
                                                    testOrPackage === "TEST"
                                                  ) {
                                                    e.target.checked === true
                                                      ? setCheckedPt([
                                                          ...checkedPt,
                                                          item,
                                                        ])
                                                      : setCheckedPt(
                                                          checkedPt?.filter(
                                                            (value) =>
                                                              value?.testId !==
                                                              item?.testId
                                                          )
                                                        );
                                                  } else if (
                                                    testOrPackage === "ADDTEST"
                                                  ) {
                                                    if (
                                                      e.target.checked === true
                                                    ) {
                                                      let flag = true;
                                                      let arr =
                                                        checkedPt?.filter(
                                                          (data) => {
                                                            if (
                                                              data.type ===
                                                                "PACKAGE" &&
                                                              item?.packageId ===
                                                                data?.packageId
                                                            ) {
                                                              flag = false;
                                                              return getSnackbarSuccess(
                                                                "warning",
                                                                "Please diselect Package to update test price ",
                                                                dispatch
                                                              );
                                                            } else {
                                                              return data;
                                                            }
                                                          }
                                                        );
                                                      if (flag === true) {
                                                        setCheckedPt([
                                                          ...arr,
                                                          item,
                                                        ]);
                                                      }
                                                    } else {
                                                      setCheckedPt(
                                                        checkedPt?.filter(
                                                          (value) =>
                                                            value?.testId !==
                                                            item?.testId
                                                        )
                                                      );
                                                      let arr = list.map(
                                                        (value) => {
                                                          if (
                                                            value?.testId ===
                                                            item?.testId
                                                          ) {
                                                            return {
                                                              ...value,
                                                              amount: 0,
                                                            };
                                                          } else {
                                                            return value;
                                                          }
                                                        }
                                                      );
                                                      setList(arr);
                                                    }
                                                  }
                                                }}
                                              />
                                            </td>
                                            <td className="text-center">
                                              {item?.testName}
                                            </td>
                                            <td>
                                              <input
                                                type="number"
                                                className={
                                                  "__inputs font-medium text-black"
                                                }
                                                style={{ width: "100%" }}
                                                placeholder="Enter here..."
                                                value={item?.amount}
                                                onKeyDown={(e) => {
                                                  if (
                                                    e.key === " " ||
                                                    e.key === "-" ||
                                                    e.key === "+"
                                                  ) {
                                                    e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                                                  }
                                                }}
                                                onChange={(e) =>
                                                  insurerPriceHandler(
                                                    index,
                                                    "amount",
                                                    e.target.value
                                                  )
                                                }
                                                disabled={
                                                  !checkedPt?.some(
                                                    (value) => value === item
                                                  )
                                                }
                                                // required={
                                                //   ele?.amount !== null &&
                                                //   ele?.amount !== ""
                                                //     ? false
                                                //     : true
                                                // }
                                              />
                                            </td>
                                          </tr>
                                        );
                                      }
                                    })}
                                  </>
                                );
                              })}
                              {addTest?.map((ele, pos) => {
                                return (
                                  <tr key={pos}>
                                    <td>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        style={{ margin: "0 50%" }}
                                        checked={checkedPt?.some(
                                          (item) => item === ele
                                        )}
                                        onClick={(e) => {
                                          e.target.checked === true
                                            ? setCheckedPt([...checkedPt, ele])
                                            : setCheckedPt(
                                                checkedPt?.filter(
                                                  (item) =>
                                                    item?.testId !== ele?.testId
                                                )
                                              );
                                        }}
                                      />
                                    </td>
                                    <td className="text-center">
                                      <span style={{ fontWeight: "900" }}>
                                        Additional Test -{" "}
                                      </span>
                                      {ele?.testName}
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        className={
                                          "__inputs font-medium text-black"
                                        }
                                        style={{ width: "100%" }}
                                        placeholder="Enter here..."
                                        value={ele?.amount}
                                        onKeyDown={(e) => {
                                          if (
                                            e.key === " " ||
                                            e.key === "-" ||
                                            e.key === "+"
                                          ) {
                                            e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                                          }
                                        }}
                                        onChange={(e) =>
                                          addTestPriceHandler(
                                            pos,
                                            "amount",
                                            e.target.value
                                          )
                                        }
                                        disabled={
                                          !checkedPt?.some(
                                            (value) => value === ele
                                          )
                                        }
                                      />
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
      <Modal
        isOpen={bulkUpload}
        className=" modal-add-user-popup modal-upload-excel-popup"
        overlayClassName="overlay-history-popup network-z-index"
        // id="advancepayoutNetwork"
        ariaHideApp={false}
      >
        <AdvanceBulkUpload
          setBulkUpload={setBulkUpload}
          bulkUpload={bulkUpload}
        />
      </Modal>
    </>
  );
};
